import React, { useState, useEffect, useContext } from "react";
import {
    Typography,
    Box,
    Button,
    Tabs,
    Tab
} from "@mui/material";
import { AutoAwesome as AutoAwesomeIcon } from "@mui/icons-material";
import { BasicInfo } from "./ConfigurationComponent/BasicInfo";
import { AiContent } from "./ConfigurationComponent/AiContent";
import { References } from "./ConfigurationComponent/Reference";
import { useTranslation, ViewContext } from "components/lib";

export function ProjectConfiguration({
    apiKey,
    basicInfo,
    setBasicInfo,
    chapters,
    setChapters,
    references,
    setReferences,
    setApiManageDialog
}) {
    const { t } = useTranslation();
    const [reqView, setReqView] = useState(0);
    const viewContext = useContext(ViewContext);

    const handleReqViewChange = (event, newValue) => setReqView(newValue);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "start",
                    backgroundColor: "#fff",
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" mb={2}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <AutoAwesomeIcon sx={{ color: "#000000", mr: 1 }} />
                        <Typography variant="h6" fontWeight="bold">
                            {viewContext.t('Components.ProjectCommon.title')}
                        </Typography>
                    </div>

                    <Button
                        sx={{
                            margin: '0px 10px',
                            marginTop: '8px',
                            backgroundColor: "#1450a0",
                            borderRadius: '8px',
                            "&:hover": { backgroundColor: "#165bb6" }
                        }}
                        variant="contained"
                        onClick={() => setApiManageDialog(true)}
                    >
                        {viewContext.t('Components.ProjectCommon.button.manage')}
                    </Button>
                </Box>

                <Tabs
                    value={reqView}
                    onChange={handleReqViewChange}
                    aria-label="User Lab Report Tabs"
                    sx={{ p: "4px", minHeight: "40px", width: "100%" }}
                >
                    <Tab
                        label={viewContext.t('Components.ProjectCommon.menu.basicInfo')}
                        sx={{
                            flex: 1,
                            textTransform: "none",
                            color: "slategrey",
                            minHeight: "32px",
                            fontWeight: 600,
                            fontSize: 16,
                            '&.Mui-selected': {
                                backgroundColor: "white",
                                color: "#1450a0",
                                borderBottom: "2px solid #1450a0",
                                "&:hover": { color: "#165bb6", borderBottom: "2px solid #165bb6" }
                            }
                        }}
                    />
                    <Tab
                        label={viewContext.t('Components.ProjectCommon.menu.aiContent')}
                        sx={{
                            flex: 1,
                            textTransform: "none",
                            color: "slategrey",
                            minHeight: "32px",
                            fontWeight: 600,
                            fontSize: 16,
                            '&.Mui-selected': {
                                backgroundColor: "white",
                                color: "#1450a0",
                                borderBottom: "2px solid #1450a0",
                                "&:hover": { color: "#165bb6", borderBottom: "2px solid #165bb6" }
                            }
                        }}
                    />
                    <Tab
                        label={viewContext.t('Components.ProjectCommon.menu.references')}
                        sx={{
                            flex: 1,
                            textTransform: "none",
                            color: "slategrey",
                            minHeight: "32px",
                            fontWeight: 600,
                            fontSize: 16,
                            '&.Mui-selected': {
                                backgroundColor: "white",
                                color: "#1450a0",
                                borderBottom: "2px solid #1450a0",
                                "&:hover": { color: "#165bb6", borderBottom: "2px solid #165bb6" }
                            }
                        }}
                    />
                </Tabs>
            </Box>

            <Box
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    scrollbarWidth: 'thin',
                    WebkitOverflowScrolling: 'touch',
                }}
            >
                {reqView === 0 && (
                    <BasicInfo
                        formData={basicInfo}
                        setFormData={setBasicInfo}
                    />
                )}
                {reqView === 1 && (
                    <AiContent
                        chapters={chapters}
                        setChapters={setChapters}
                        basicInfo={basicInfo}
                        apiKey={apiKey}
                        setApiManageDialog={setApiManageDialog}
                    />
                )}
                {reqView === 2 && (
                    <References references={references} setReferences={setReferences} />
                )}
            </Box>
        </Box>
    );
}